(() => {
  let isFormatting = false;

  function convertTrademarkToSuperscript(root = document) {
    if (isFormatting) return;

    isFormatting = true;

    const elements = root.querySelectorAll(
      'h1, h2, h3, h4, h5, h6, p, a, button, span'
    );

    elements.forEach((element) => {
      // Do not process elements inside scripts, styles, or existing superscripts.
      if (
        element.closest('script, style, textarea, code, pre, sup') ||
        element.children.length > 0
      ) {
        return;
      }

      const text = element.textContent || '';

      // Match:
      // AlgaDermTM
      // ComplexTM
      // AlgaDerm™
      if (!/[A-Za-z](?:TM|™)/.test(text)) {
        return;
      }

      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            const value = node.nodeValue || '';

            if (!/[A-Za-z](?:TM|™)/.test(value)) {
              return NodeFilter.FILTER_REJECT;
            }

            if (node.parentElement?.closest('sup')) {
              return NodeFilter.FILTER_REJECT;
            }

            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      const textNodes = [];

      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      textNodes.forEach((textNode) => {
        const value = textNode.nodeValue;
        const regex = /([A-Za-z])(?:TM|™)/g;

        let lastIndex = 0;
        let match;
        let found = false;

        const fragment = document.createDocumentFragment();

        while ((match = regex.exec(value)) !== null) {
          found = true;

          // Add everything before the matched letter.
          fragment.appendChild(
            document.createTextNode(value.slice(lastIndex, match.index))
          );

          // Add the letter before TM.
          fragment.appendChild(document.createTextNode(match[1]));

          // Add superscript trademark.
          const sup = document.createElement('sup');
          sup.className = 'st-trademark';
          sup.textContent = match[0].endsWith('™') ? '™' : 'TM';

          fragment.appendChild(sup);

          lastIndex = regex.lastIndex;
        }

        if (!found) return;

        fragment.appendChild(
          document.createTextNode(value.slice(lastIndex))
        );

        textNode.replaceWith(fragment);
      });
    });

    isFormatting = false;
  }

  function initializeTrademarkFormatting() {
    convertTrademarkToSuperscript();

    if (document.documentElement.dataset.stTrademarkObserver === 'true') {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            window.requestAnimationFrame(() => {
              convertTrademarkToSuperscript(node);
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.documentElement.dataset.stTrademarkObserver = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeTrademarkFormatting,
      { once: true }
    );
  } else {
    initializeTrademarkFormatting();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeTrademarkFormatting
  );
})();